// created by AI
import { matchesSelectableLabelSearch } from "@utils/helpers/selectSearch"
import { compareByFilterMatch } from "open-lib"

// created by AI
// Keep option labels as the primary search surface, matching how sensor dropdowns are
// shown to users, while still handling number labels or values without throwing.
export function getSelectOptionSearchText(option: { label: unknown; value?: unknown }): string {
	if (typeof option.label === "string" || typeof option.label === "number") {
		return option.label.toString()
	}
	if (typeof option.value === "string" || typeof option.value === "number") {
		return option.value.toString()
	}
	return ""
}

// created by AI
// Match the original label first, then try the alpha/numeric-expanded variant. This
// lets "dg power" find "DG1 Power" while preserving normal exact and wildcard search.
export function matchesSelectOptionFilterSearch(
	searchText: string,
	optionText: string
): boolean {
	return matchesSelectableLabelSearch(searchText, optionText)
}

// created by AI
// Sort visible dropdown results the same way the status page's "filter match" sort does,
// but leave the original order alone when the search box is empty.
export function sortSelectOptionsByFilterMatch<T extends { label: unknown; value?: unknown }>(
	options: T[],
	searchText: string
): T[] {
	if (searchText === "") return options

	return [...options].sort((a, b) =>
		compareByFilterMatch(
			searchText,
			getSelectOptionSearchText(a),
			getSelectOptionSearchText(b)
		)
	)
}
